import axios from 'axios';
import toast from 'react-hot-toast';

import { apiUrl } from '../apiUrl';
import i18n from '../../i18n';

export const fetchOneTimeWorkshops = async ({ franchiseId }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/newSummerplay/${franchiseId}/one_time_workshops`,
    );

    return response.data.summerplay_groups || [];
  } catch (error) {
    toast.error(
      i18n.t('apiErrors.oneTimeWorkshopGroups'),
    );

    return [];
  }
};
